import { IVBioTypeOptions, IVDetergenzaTypeOptions, IVGGAPTypeOptions, IVNFTypeOptions, IVQSTypeOptions, IVRZTypeOptions, IVSQNPITypeOptions, IVTypeOptions, OptionType } from "../../utils"
import { ServiceTypeNormEnum } from "../schedaCalcolo/dataService/dto"

export const getOptions = (norm: string) => {
    let options: OptionType[] = []
    switch (norm) {
        case ServiceTypeNormEnum.NORMA_BIO:
            options = IVBioTypeOptions
            break

        case ServiceTypeNormEnum.QUALITA_SICURA:
            options = IVQSTypeOptions
            break

        case ServiceTypeNormEnum.NORMA_BIO:
            options = IVBioTypeOptions
            break

        case ServiceTypeNormEnum.DETERGENZA:
            options = IVDetergenzaTypeOptions
            break

        case ServiceTypeNormEnum.PRODUZIONE_INTEGRATA:
            options = IVSQNPITypeOptions
            break

        case ServiceTypeNormEnum.NICHEL_FREE:
            options = IVNFTypeOptions
            break

        case ServiceTypeNormEnum.GLOBAL_GAP:
            options = IVGGAPTypeOptions
            break

        case ServiceTypeNormEnum.RESIDUO_ZERO:
            options = IVRZTypeOptions
            break
        
        default:
            options = IVTypeOptions
            break
    }

    return options
}